var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 95,
    viewBox: "0 0 122 95",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.79883L13.8 7.63943M2 2.79883V87.5093L13.8 92.3499M2 2.79883H105.84L120 7.63943M13.8 7.63943V22.1612M13.8 7.63943C23.6287 7.63943 36.1864 7.63943 49.2 7.63943M120 7.63943V22.1612M120 7.63943C120 7.63943 104.614 7.63943 84.6 7.63943M13.8 92.3499V22.1612M13.8 92.3499H49.2M13.8 22.1612H120M120 22.1612V92.3499H84.6M84.6 7.63943V92.3499M84.6 7.63943C73.6022 7.63943 61.207 7.63943 49.2 7.63943M84.6 92.3499H49.2M49.2 7.63943V92.3499",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0807 37.8815H109.533V77.6504H96.0807V37.8815Z",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3503 37.8815H37.8026V77.6504H24.3503V37.8815Z",
    stroke: "#B1B1B1",
    strokeWidth: 3.95052
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6406 58.4659L71.6115 38.2422L68.0806 53.6253H75.1606L63.3346 73.2602L66.518 58.4659H58.6406Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBess);
export default __webpack_public_path__ + "static/media/bess.a557107db1bf404ba2ad85850af17ea9.svg";
export { ForwardRef as ReactComponent };